import { render, staticRenderFns } from "./DealsAndPromotions.vue?vue&type=template&id=a486a250&scoped=true&"
import script from "./DealsAndPromotions.vue?vue&type=script&lang=js&"
export * from "./DealsAndPromotions.vue?vue&type=script&lang=js&"
import style0 from "./DealsAndPromotions.vue?vue&type=style&index=0&id=a486a250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a486a250",
  null
  
)

export default component.exports